/* eslint-disable @typescript-eslint/no-explicit-any */
import { NavigationBarService } from './navigation-bar.service';
import { NavigationBarModule } from './navigation-bar.module';

export function NavigationBar(color: string): ClassDecorator {
  return function (target: any) {
    const originalMethod = target.prototype.ionViewWillEnter;

    target.prototype.ionViewWillEnter = async function (...args: any) {
      const navigationBarService = NavigationBarModule.injector.get(NavigationBarService);
      await navigationBarService.setBackgroundColor(color);

      originalMethod?.apply(this, args);
    };
  };
}
